import is from '@sindresorhus/is';
import { z } from 'zod';

import { type LanguageCodeForJSA, languageCodeSchemaForJSA } from '~/shared/internationalization';

export const JSA_WORK_TASK_TILE_TYPE = 'v1.jsa.work-task' as const;
export const WORK_TASK_TILE_SLOT_KEY = 'jsa.work-task';
export const WORK_TASK_TILE_WIDTH = '500px';

/** A work task read by id, optionally pinned to one version; the content language is presentation state. */
export const workTaskTileSchema = z.object({
    isCommentsOpen: z.boolean().optional(),
    language: languageCodeSchemaForJSA.optional(),
    taskId: z.string().trim().min(1),
    type: z.literal(JSA_WORK_TASK_TILE_TYPE),
    version: z.number().int().positive().optional(),
});

export type WorkTaskTilePayload = z.infer<typeof workTaskTileSchema>;

export const createWorkTaskTilePayload = ({
    isCommentsOpen,
    language,
    taskId,
    version,
}: {
    readonly isCommentsOpen?: boolean;
    readonly language?: LanguageCodeForJSA;
    readonly taskId: string;
    readonly version?: number;
}): WorkTaskTilePayload => ({
    ...(!is.undefined(isCommentsOpen) ? { isCommentsOpen } : {}),
    ...(!is.undefined(language) ? { language } : {}),
    taskId,
    type: JSA_WORK_TASK_TILE_TYPE,
    ...(!is.undefined(version) ? { version } : {}),
});

export const isWorkTaskTilePayload = (payload: unknown): payload is WorkTaskTilePayload =>
    is.plainObject(payload) && payload['type'] === JSA_WORK_TASK_TILE_TYPE;
